import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  standalone: false,
})
export class DateInputComponent {
  @Input() public formCtrl: FormControl | undefined;

  @Input() public label: string = '';

  @Input() public placeholder: string = '';

  @Input() public hintMessage: string = '';

  @Input() public fromMon2Fri: boolean | undefined;

  @Input() public day: Date | undefined;

  @Input() public disabled: boolean = false;

  @Input() public isOnlyMonday: boolean = false;

  @Input() public isOnlyFriday: boolean = false;

  @Input() public isTodayMinDate = false;

  @Input() public minDate: Date | null = null;

  @Input() public isTwoWeeksMaxDate: boolean = false;

  @Input() public maxDate: Date | null = null;

  @Input() public isNextWeekMinDate = false;

  @Output() public dateChanged = new EventEmitter();

  constructor() {}

  changeDay(event: any) {
    this.dateChanged.emit(event);
  }
}
